// src/components/Admin/Auth/Auth.js
import React, { useState } from "react";
import { RegisterForm, LoginForm } from "../../../components/Admin/Auth"; // mismo barrel
import { logoEduca } from "../../../assets";
import "./Auth.scss";

export function Auth() {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Logo de Educa360 */}
        <img src={logoEduca.logoE360} alt="Educa360" className="auth-logo" />

        {/* Aquí pasamos openLogin al RegisterForm */}
        {isLogin ? (
          <LoginForm />
        ) : (
          <RegisterForm openLogin={() => setIsLogin(true)} />
        )}

        {/* Link para cambiar entre Login y Sign Up */}
        <div className="auth-switch">
          {isLogin ? (
            <>
              ¿No tienes cuenta?{" "}
              <button
                type="button"
                className="link-btn"
                onClick={() => setIsLogin(false)}
              >
                Crear nueva cuenta
              </button>
            </>
          ) : (
            <>
              ¿Ya tienes cuenta?{" "}
              <button
                type="button"
                className="link-btn"
                onClick={() => setIsLogin(true)}
              >
                Entrar
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
